import { API_BASE_URL } from "../../../../core/constants/app_constants";
import axios from "axios";
import ChatAPIService from "../chat_api_service";
import apiUtils from "../../../../core/utils/api_utils";
import { USER_TOKEN_KEY } from "../../../../core/constants/app_constants";

class ChatAPIServiceImpl extends ChatAPIService {
    static #instance = null; // Private static instance

    constructor() {
        if (ChatAPIServiceImpl.#instance) {
            return ChatAPIServiceImpl.#instance; // Return existing instance instead of creating a new one
        }
        super(); // Call parent constructor
        ChatAPIServiceImpl.#instance = this; // Store instance
    }

    /**
     * Initializes a chat session for a user
     * @param {Object} data - The initialization data
     * @param {string} data.userId - The unique identifier of the user (24-character MongoDB ObjectId)
     * @returns {Promise<Object>} Response containing success status and chat initialization data
     * @example
     * const data = {
     *   userId: "67b4a28b3820cf3aef88de6a"
     * };
     * const result = await initChat(data);
     */
    async initChat(data) {
        try {
            const response = await apiUtils.post(`/api/chat/init`, data);
            return response.data;
        } catch (err) {
            return err.response ? err.response.data : { success: false, message: "Something went wrong", data: [] };
        }
    }

    async getMessages({ chatChannelId, skip, limit }) {
        try {
            const response = await apiUtils.get(`/api/chat/messages/${chatChannelId}/${skip}/${limit}`);
            return response.data;
        } catch (err) {
            return err.response ? err.response.data : { success: false, message: "Something went wrong", data: [] };
        }
    }

    async getPreviousMessages(chatChannelId) {

    }

    async chatCompletion(data) {
        try {
            console.log("Chat Completion Data", data);
            const response = await apiUtils.post(`/api/chat/completion`, data);
            return response.data;
        } catch (err) {
            console.log("Chat Completion Error", err);
            return err.response ? err.response.data : { success: false, message: "Something went wrong", data: [] };
        }
    }

    async startVideoCall(data) {
        try {
            const response = await apiUtils.post(`/api/chat/start-video-call`, data);
            return response.data;
        } catch (err) {
            return err.response ? err.response.data : { success: false, message: "Something went wrong", data: [] };
        }
    }

    async endVideoCall(data) {
        try {
            const response = await apiUtils.post(`/api/chat/end-video-call`, data);
            return response.data;
        } catch (err) {
            return err.response ? err.response.data : { success: false, message: "Something went wrong", data: [] };
        }
    }

    async startVoiceCall(data) {
        try {
            const response = await apiUtils.post(`/api/chat/start-voice-call`, data);
            return response.data;
        } catch (err) {
            return err.response ? err.response.data : { success: false, message: "Something went wrong", data: [] };
        }
    }

    async endVoiceCall(data) {
        try {
            const response = await apiUtils.post(`/api/chat/end-voice-call`, data);
            return response.data;
        } catch (err) {
            return err.response ? err.response.data : { success: false, message: "Something went wrong", data: [] };
        }
    }

    async clearChat(data) {
        try {
            const response = await apiUtils.post("/api/chat/clear-chat-message", data);
            return response.data;
        } catch (e) {
            return e.response ? e.response.data : { success: false, message: "Something went wrong", data: { exception: e } };
        }
    }

}

export default ChatAPIServiceImpl;